export enum pageCategoryTypes {
  DataGeneratedBy = 'DATA_GENERATED_BY'
}
